import { HelpCircle } from 'lucide-react';
import { useTour } from './TourContext';
import { useLocation } from 'react-router-dom';

// Mapping des routes vers les IDs de tour
// IMPORTANT: Les routes doivent être ordonnées de la plus spécifique à la moins spécifique
// car la logique utilise startsWith() et retourne le premier match
const routeToTourMap: Record<string, { id: string; label: string }> = {
  '/stock/predictions': {
    id: 'stock-predictions',
    label: 'Prédictions',
  },
  // Routes produits - ordre important: spécifique → général
  '/stock/products/new': {
    id: 'stock-product-form',
    label: 'Formulaire produit',
  },
  '/stock/products/edit': {
    id: 'stock-product-form',
    label: 'Formulaire produit',
  },
  '/stock/products/archived': {
    id: 'stock-products-archived',
    label: 'Produits archivés',
  },
  '/stock/products/': {
    id: 'stock-product-detail',
    label: 'Détails produit',
  },
  '/stock/products': {
    id: 'stock-products-list',
    label: 'Liste des produits',
  },
  '/stock/reception': {
    id: 'stock-reception',
    label: 'Réception de stock',
  },
  '/stock/suppliers/new': {
    id: 'stock-supplier-form',
    label: 'Formulaire fournisseur',
  },
  '/stock/suppliers/': {
    id: 'stock-supplier-detail',
    label: 'Détails fournisseur',
  },
  '/stock/suppliers': {
    id: 'stock-suppliers',
    label: 'Fournisseurs',
  },
  '/stock/orders': {
    id: 'stock-orders',
    label: 'Commandes',
  },
  '/stock/cart': {
    id: 'stock-cart',
    label: 'Panier',
  },
  '/stock/invoices': {
    id: 'stock-invoices',
    label: 'Factures',
  },
  '/stock/export': {
    id: 'stock-export',
    label: 'Export comptable',
  },
  '/stock/expirations': {
    id: 'stock-expiries',
    label: 'Péremptions',
  },
  '/stock/sortie': {
    id: 'stock-sortie',
    label: 'Sortie de stock',
  },
  '/stock/consumers/': {
    id: 'stock-consumer-detail',
    label: 'Détail consommateur',
  },
  '/stock/smart-order': {
    id: 'stock-smart-order',
    label: 'Commande intelligente',
  },
  '/stock/anomalies': {
    id: 'stock-anomalies',
    label: 'Anomalies Stock',
  },
  '/stock/journal': {
    id: 'stock-journal',
    label: 'Journal d\'activité',
  },
  '/stock/settings': {
    id: 'stock-settings',
    label: 'Paramètres',
  },
  '/stock': {
    id: 'stock-dashboard',
    label: 'Tableau de bord',
  },
};

export function TourButton() {
  const { startTour, isTourActive } = useTour();
  const location = useLocation();

  // Trouver le tour correspondant à la route actuelle
  // Logique spéciale pour les routes d'édition qui utilisent le pattern /:id/edit
  let currentTour: { id: string; label: string } | undefined;

  if (location.pathname.includes('/edit')) {
    // Page d'édition - détermine le bon tour selon le module
    if (location.pathname.includes('/suppliers/')) {
      currentTour = { id: 'stock-supplier-form', label: 'Formulaire fournisseur' };
    } else if (location.pathname.includes('/products/')) {
      currentTour = routeToTourMap['/stock/products/edit'];
    }
  } else {
    // Cherche la route la plus spécifique qui correspond
    currentTour = Object.entries(routeToTourMap).find(([route]) =>
      location.pathname.startsWith(route)
    )?.[1];
  }

  if (isTourActive || !currentTour) {
    return null; // Cache le bouton pendant un tour actif ou si pas de tour pour cette page
  }

  return (
    <button
      onClick={() => startTour(currentTour.id)}
      className="p-2 rounded-lg hover:bg-neutral-100 transition-colors text-primary-600"
      title={`Démarrer le tour : ${currentTour.label}`}
      aria-label="Démarrer le tour guidé"
    >
      <HelpCircle size={20} />
    </button>
  );
}
